export const SET_SELECTED_PLACE_TO_ADD = 'SET_SELECTED_PLACE_TO_ADD';
export const OPEN_STEP_PROFILE = 'OPEN_STEP_PROFILE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_TEMP_PENDING_ID = 'SET_TEMP_PENDING_ID';
export const ADD_PENDING_CHANGED_LOCATION = 'ADD_PENDING_CHANGED_LOCATION';
export const SET_OPEN_TAGS = 'SET_OPEN_TAGS';
export const EXPIRED_FORGOT_TOKEN = 'EXPIRED_FORGOT_TOKEN';
export const GO_TO = 'GO_TO';
